import { render, staticRenderFns } from "./DepartamentoIbpModal.vue?vue&type=template&id=04d110dc&scoped=true"
import script from "./DepartamentoIbpModal.vue?vue&type=script&lang=js"
export * from "./DepartamentoIbpModal.vue?vue&type=script&lang=js"
import style0 from "./DepartamentoIbpModal.vue?vue&type=style&index=0&id=04d110dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d110dc",
  null
  
)

export default component.exports